module.exports = __webpack_public_path__ + "img/caret_down.856c4410.png";